module.exports = __webpack_public_path__ + "img/logo-bemyvega.0dd78641.png";